"use client";

import { Toaster, SileoStyles } from "sileo";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function SileoToaster() {
  const { theme, resolvedTheme } = useTheme();
  const [isMobile, setIsMobile] = useState<boolean | null>(null);



  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);



  if (isMobile === null) return null;

  const currentTheme = resolvedTheme || theme;
  const isDark = currentTheme === "dark";

  return (
    <Toaster
      position={isMobile ? "top-center" : "bottom-right"}
      offset={isMobile ? { top: 24 } : { bottom: 24, right: 24 }}
      options={{
        fill: isDark ? "#000000" : "#f2f2f2",
        roundness: 16,
        styles: {
          title: "text-[hsl(var(--toast-foreground))] font-bold! text-[15px]",
          description: "text-[hsl(var(--toast-muted))]! text-[13px] leading-relaxed",
          badge: "bg-primary/10 text-primary!",
          button: "bg-primary hover:bg-primary/90 text-white font-semibold! rounded-xl transition-all duration-200",
          icon: "text-primary",
        } as SileoStyles,
      }}
    />
  );
}
